<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <EmptyState :title="widget.content.empty_state_message" with-icon v-if="widget.content.count === 0" />

        <template v-if="widget.content.count === 1">
            <div v-if="widget.content.best !== null">
                {{
                    $tc('messages.doing_well_on_subject_X', 10, {
                        subject: widget.content.best,
                    })
                }}
            </div>
            <div v-if="widget.content.worst !== null">
                {{
                    $tc('messages.needs_to_improve_subject_X', 10, {
                        subject: widget.content.worst,
                    })
                }}
            </div>
        </template>

        <template v-else>
            <div v-if="widget.content.best !== null">
                {{
                    $tc('messages.doing_well_on_subject_X', 10, {
                        subject: widget.content.best,
                    })
                }}
            </div>
            <div v-if="widget.content.worst !== null">
                {{
                    $tc('messages.needs_to_improve_subject_X', 10, {
                        subject: widget.content.worst,
                    })
                }}
            </div>
        </template>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import EmptyState from '@/components/EmptyState.vue';

export default {
    name: 'BestAndWorstSubjectsWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
        EmptyState,
    },
};
</script>
